import { gql } from "@apollo/client";

export const setLensCreatorPayoutEnrollmentData = gql`
    mutation setLensCreatorPayoutEnrollment($lensId: ID!, $lensCreatorPayoutEnrolled: Boolean!) {
        setLensCreatorPayoutEnrollment(
            input: { lensId: $lensId, lensCreatorPayoutEnrolled: $lensCreatorPayoutEnrolled }
        ) {
            lens {
                id
                lensCreatorPayoutEligibility
                status
            }
        }
    }
`;
